import { render, staticRenderFns } from "./MessengersPopup.vue?vue&type=template&id=1e53341a"
import script from "./MessengersPopup.vue?vue&type=script&lang=js"
export * from "./MessengersPopup.vue?vue&type=script&lang=js"
import style0 from "./MessengersPopup.vue?vue&type=style&index=0&id=1e53341a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports